<div class="custom-dialog-wrapper">
    <h1 mat-dialog-title class="custom-dialog-title">{{ data.title || 'Title'}}</h1>
    <div mat-dialog-content>
        <ng-container *ngIf="data.type === SelectTableDialogType.SELECT_ITEM_TABLE">
            <app-select-item-table (onSelectedChange)="onTableNumberSelectedChange($event)"
                [selectedItemNumbers]="selectedNumbers"
                [filterItemNumbers]="data.filterNumbers" [isScrollWithinTable]="true"></app-select-item-table>
        </ng-container>
        <ng-container *ngIf="data.type === SelectTableDialogType.SELECT_VENDOR_TABLE">
            <app-select-vendor-table (onSelectedChange)="onTableStringSelectedChange($event)"
                [selectedVendorNumbers]="selectedStrings"
                [filterVendorNumbers]="data.filterStrings" [isScrollWithinTable]="true"></app-select-vendor-table>
        </ng-container>

    </div>
    <div mat-dialog-actions class="custom-dialog-buttons mt-5">
        <app-button class="padBtn cancel-button" name="Cancel" mat-dialog-close></app-button>
        <app-button class="padBtn action-button" [name]="data.actionButtonText || 'Confirm'" type="flat-button"
            cdkFocusInitial (click)="onDialogAction()"></app-button>
    </div>
</div>